export const initialState = false;

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SAVE_MY_ZONE_FEATURE_FLAG':
            return action.data.my_zone;
        default:
            return state;
    }
};
